import {
  Box,
  BoxProps,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { useProduct } from '../../../../../../../../../../hooks/product';
import { ProductAppointmentList } from './components/ProductAppointmentList';

export const ProductDetailsTabs = (props: BoxProps): JSX.Element => {
  const { product } = useProduct();

  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return product ? (
    <Box {...props}>
      <Tabs
        index={tabIndex}
        onChange={handleTabChanges}
        variant="enclosed-colored"
        isLazy
      >
        <TabList>
          <Tab>Ordens de serviço</Tab>
        </TabList>

        <TabPanels mt="4">
          <TabPanel>
            <ProductAppointmentList />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  ) : (
    <></>
  ); // loading view
};
